import './reportcard.css';
import iconMap from '../../utils/iconMap.json';

const toKey = (v) => String(v).trim().toLowerCase();

const ReportCard = ({ title, variant = title, description, onClick }) => {
  const key = toKey(variant);
  const ICONS = iconMap;
  const { src, alt } = ICONS[key] ?? ICONS.report;

  return (
    <div className="reportCard" onClick={onClick}>
      <div className="reportCardLogo">
        <img src={src} alt={alt} />
      </div>
      <div className="reportCardTitle">
        <h1>{title}</h1>
      </div>
    </div>
  );
};

export default ReportCard;